<template>
  <div class="demo-home-layout">
    <DemoTopNav />
    <main class="demo-home-layout__main">
      <router-view />
    </main>
  </div>
</template>

<script>
import DemoTopNav from "@/components/demo/DemoTopNav.vue";

export default {
  name: "DemoHomeLayout",
  components: { DemoTopNav },
};
</script>

<style lang="scss" scoped>
.demo-home-layout {
  min-height: 100vh;
  padding-top: 56px;
  box-sizing: border-box;
  background: #f0f2f5;
}

.demo-home-layout__main {
  min-height: calc(100vh - 56px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: linear-gradient(165deg, #f0f4fa 0%, #f7f9fc 38%, #fafcfd 100%);
}
</style>
